<template>
  <div>
    <div
      style="width: 1300px; margin: 0 auto"
      id="v-content"
      :style="{ minHeight: Height + 'px' }"
    >
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2 font" style="margin-bottom: 10px">
          <img
            src="../../static/images/chaxun.png"
            style="width: 1.5rem; height: 1.5rem"
            class="mb-lg-1"
            alt=""
          />
          <span
            class="p-1"
            style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            "
          >
            活动品种
          </span>
        </p>
        <div class="row ml-2 mb-2 mt-2" style="position: relative">
          <div class="col-lg-8">
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-4">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">药品名称:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="params.ypmc"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">规格:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="params.gg"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">生产厂家:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="params.cdmc"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8" style="margin-top: 10px">
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-4">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">汇总方式:</div>
                      <div class="col-lg-6 p-0">
                        <el-select
                          size="mini"
                          style="height: 1.5rem"
                          v-model="params.hzby"
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in options1"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">搜索天数:</div>
                      <div class="col-lg-6 p-0">
                        <el-select
                          size="mini"
                          style="height: 1.5rem"
                          v-model="params.days"
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in options2"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="row">
                      <el-button
                        type="primary"
                        style="margin-left: 40px; padding: 5px 8px"
                        @click="search()"
                        >搜索</el-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showPage">
          <table class="table table-striped table-hover" ref="print">
            <thead>
              <tr style="white-space: nowrap">
                <th>药品名称</th>
                <th>次数</th>
                <th>规格</th>
                <th>产地</th>
                <th v-if="showType==2">客户类别</th>
                <th v-if="showType==3">客户名称</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in tableData" :key="index">
                <td>{{ item.ypmc }}</td>
                <td>{{ item.count }}</td>
                <td>{{ item.gg }}</td>
                <td>{{ item.cdmc }}</td>
                <td v-if="showType==2">{{ item.lb }}</td>
                <td v-if="showType==3">{{ item.khmc }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <img
            src="../../static/images/wushuju.jpg"
            style="width: 300px; height: 300px; display: block; margin: 0 auto"
            alt=""
          />
        </div>
      </div>
    </div>
    <div>
      <transition name="fade">
        <loading v-if="isLoading"></loading>
      </transition>
    </div>
  </div>
</template>
<script>
import vPagination from "../components/Pagination.vue";
import Loading from "../components/Loading.vue";

export default {
  name: "SaleQuery",
  data() {
    return {
      params: {
        ypmc: "",
        cdmc: "",
        gg: "",
        clerkno: "",
        hdid: null,
        hzby: "1",
        days: 1,
      },
      options1: [
        {
          name: "药品",
          value: "1",
        },
        {
          name: "客户类型",
          value: "2",
        },
        {
          name: "客户",
          value: "3",
        },
      ],
      options2: [
        {
          name: "1",
          value: 1,
        },
        {
          name: "3",
          value: 3,
        },
        {
          name: "7",
          value: 7,
        },
      ],
      Height: 0, //搜索返回的清单
      isLoading: false,
      showPage: true,
      tableData: [],
      total: 0, //总条数
      current: 1, //当前页
      showType: null,
    };
  },
  components: {
    vPagination,
    Loading,
  },
  computed: {},
  methods: {
    getClerkGoodsForward: async function () {
      const that = this;
      that.isLoading = true;
      const { data: res } = await this.$http.post(
        "DsApi/GetSearchhz",
        this.params
      );
      that.isLoading = false;
      if (res.isok) {
        that.showType = that.params.hzby;
        that.tableData = res.list;
      }
    },
    pagechange(current) {
      this.params.PageIndex = current;
      try {
        this.getClerkGoodsForward();
      } catch (error) {
        console.error("Failed to fetch clerk goods forward:", error);
      }
    },
    search() {
      this.getClerkGoodsForward();
    },
  },
  mounted() {
    this.getClerkGoodsForward();
    //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100; //监听浏览器窗口变化
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight - 100;
    };
  },
};
</script>
<style scoped>
.table-hover > tbody > tr:hover {
  background-color: #dee2e6 !important;
}
.table {
  margin-bottom: 60px;
}
.hei {
  height: 1.5rem;
}
.font {
  font-size: 15px;
}
.font_yz {
  font-size: 1px;
  color: red;
}
.button_zi {
  text-shadow: #000 1px 0 0;
  border-radius: 5px;
  border: none;
  color: azure;
}
.money {
  color: red;
  font-weight: 500;
}
.span_close:hover {
  color: #3190e8;
}
.totalNum {
  color: green;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/pages/cxhz.vue